import { render, staticRenderFns } from "./FilterMenuObjectStore.vue?vue&type=template&id=45ad087d"
import script from "./FilterMenuObjectStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterMenuObjectStore.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports